import React, { ReactNode, useContext, useEffect } from 'react';
import { AuthContext } from '../Auth/components/AuthProvider';
import { Loading } from './system/Loading';
import { NavigateFunction, useNavigate } from 'react-router';

export const LogoutPage: React.FC = (): ReactNode => {
  const {actions} = useContext(AuthContext);
  const navigate: NavigateFunction = useNavigate();

  useEffect(() => {
    actions.logout();
    void navigate('/');
  }, []);

  return <Loading/>;
};

export default LogoutPage;
